if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        //formData.append('price', "2.99");
        //console.log(formData);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log(response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

$(document).ready(function() {
 
  
  // Price load after clicking on variant
  $(document).on("change", ".product-form__input input[type='radio']", function() {
    setTimeout(function() {    
    //GetPrice();      
    }, 1000);
  });

  $(document).on("click", ".product-form__input .quantity button", function() {
    setTimeout(function() {    
   // GetPriceByQtybreak();      
    }, 200);
  });

  // By default Its load price 
  setTimeout(function() {  
   // GetPrice();      
    }, 200);
});

function GetPrice()
{
    var sku = $(".prosku").text();
    var customerG= $("#customerpricegroup").val();
    var qty= $(".product-form__quantity .quantity__input").val();
    console.log("GetPrice "+sku+" ==> "+customerG+" ==>"+qty);
     
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
            var priceData = JSON.parse(this.responseText);
            console.clear();
            console.log(priceData);
            console.log(priceData[0].price);
            $(".price-item.price-item--regular").text("$" + priceData[0].price);
        }
    });    
    xhr.open("GET","https://sandybrown-viper-258024.hostingersite.com/fetch.php?ct="+customerG+"&item="+sku+"&qty="+qty);
    xhr.send();   
  }
function GetPriceByQtybreak()
{
      var sku = $(".prosku").text();
      var customerG= $("#customerpricegroup").val();
      var qty= $(".product-form__quantity .quantity__input").val();
      console.log("GetPriceByQtybreak "+sku+" ==> "+customerG+" ==>"+qty);
    
     // var URL = 'https://d1-int.iscorp.com/UpSideDown/distone/rest/service/price/breaks?item='+sku+'&customer='+customerG+'&warehouse=PA';
      var data = JSON.stringify([]);      
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      
      xhr.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          var priceData = JSON.parse(this.responseText);
            priceData.forEach(function(item, index) {
              var startFrom = item.from;
              var startTo = item.to;
              var price = item.amount;
              if(item.to  == 0)
              {
                startTo = 9999999;
              }
              if(qty >= startFrom  &&  qty <= startTo)
              {
                price = item.amount;
                $(".price-item.price-item--regular").text("$"+price)
              }              
            });
          //console.log(priceData[0].price);
          //$(".price-item.price-item--regular").text("$"+priceData[0].price)
        }
      });      
    xhr.open("GET","https://sandybrown-viper-258024.hostingersite.com/breaks.php?ct="+customerG+"&item="+sku);
    xhr.send();
}


/*
fetch('/cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates: { '45118013178005': 100 } })
})
.then(response => response.json())
.then(data => console.log(data));
*/
/*
// Update the line item price in the cart
function updateCartItemPrice(lineItemId, newPrice) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates: { [lineItemId]: newPrice } })
  })
  .then(response => response.json())
  .then(data => console.log(data))
  .catch(error => console.error('Error:', error));
}

// Example usage
updateCartItemPrice('45118013178005', 1999); // Replace with your line item ID and new price in cents
*/

/*
// Function to fetch the cart details
function fetchCart() {
  return $.getJSON('/cart.js');
}

// Function to update a line item's quantity or price
function updateCartLine(lineItemId, quantity) {
  return $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: lineItemId, // Line item ID from the cart
      quantity: quantity, // New quantity
      properties: {
        Discount: `Discount applied: $${(20 / 100).toFixed(2)}` // Add a custom property
      }
    },
    dataType: 'json',
  });
}
updateCartLine('45118013178005', 96);
// Apply discounts to line items
function applyDiscount() {
  fetchCart().then((cart) => {
    const lineItems = cart.items;

    lineItems.forEach((item) => {
      const originalPrice = item.original_price; // Original price in cents
      const discountAmount = 20; // Discount of $9.00 in cents
      const newPrice = originalPrice - discountAmount;

      // Simulate a discount by reducing the quantity (or use notes)
      const discountMessage = 'Discount applied: $9.00';
      console.log(`Updating ${item.title}: Original Price = $${originalPrice / 100}, New Price = $${newPrice / 100}`);
    });
  });
}

// Trigger the discount application
$(document).ready(() => {
  applyDiscount();
});
*/


/*
$(document).ready(function() {
  $(".product-form__input input").change(function() {
    // Code to execute when the button is clicked
    console.log($(".prosku").text());
    var sku = $(".prosku").text();
    
    var data = JSON.stringify([
      {
        "customer": "DECO001",
        "item": sku,
        "unit": "EA",
        "quantity": 1,
        "warehouse": "PA"
      }
    ]);
    
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    
    xhr.addEventListener("readystatechange", function() {
      if(this.readyState === 4) {
        console.log(JSON.parse(this.responseText));
      }
    });
    
    xhr.open("POST", "https://d1-int.iscorp.com/UpSideDown/distone/rest/service/price/fetch");
    xhr.setRequestHeader("Authorization", "yr9f28z2W7uQFDWd7MoqwA");
    xhr.setRequestHeader("Content-Type", "application/json");
    
    xhr.send(data);
  });
});*/
